import React from "react";
import {
  stringSlicer,
  totalAmountCalculator,
} from "../../../../../utility/bulkDataModifier";
import ResizeListener from "../../../../../utility/ResizeListener";
import "./index.css";
import { numberWithCommas } from "../../../../../utility/commaSeperator";
import { CustomButton } from "../../../../components/customButton/CustomButton";
function DisplayBulk({ data = [], onClickSubmit, loading = false }) {
  const { width, height } = ResizeListener();
  return (
    <div
      style={{
        minWidth: 600,
        width: width * 0.7,
        height: height * 0.63,
        backgroundColor: "white",
        borderRadius: 30,
        padding: "15px 25px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "90%",
        }}
      >
        <p
          style={{
            fontSize: 14,
            fontWeight: "bold",
            margin: "10px 0px",
          }}
        >
          Preview
        </p>
      </div>

      <div
        style={{
          maxHeight: 400,
          width: "90%",
          border: "1px solid grey",
          overflow: "auto",
          position: "relative",
        }}
      >
        <table
          className="table-1"
          style={{
            padding: "10px 20px",
            minWidth: 550,
          }}
        >
          <thead
            className="thead-1"
            style={{
              height: 50,
              position: "sticky",
              zIndex: 100,
              top: 0,
              backgroundColor: "white",
            }}
          >
            <tr className="tr-1" style={{}}>
              <th className="th-1">Name as per bank</th>
              <th className="th-1">Account Number</th>
              <th className="th-1">IFSC</th>
              <th className="th-1">Amount</th>
              <th className="th-1">Payment Method</th>
            </tr>
          </thead>

          <tbody style={{}}>
            {data &&
              data?.map((tab, i) => (
                <tr className="tr-1" key={i}>
                  <td className="th-1">
                    {stringSlicer(tab?.beneficiaryName, 30)}
                  </td>
                  <td className="th-1">
                    {stringSlicer(tab.accountNumber, 30)}
                  </td>
                  <td className="th-1">{tab?.ifscCode}</td>
                  <td className="th-1">{tab?.amount}</td>
                  <td className="th-1">{tab?.type}</td>
                </tr>
              ))}
          </tbody>
        </table>
        <div
          style={{
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            marginRight: 30,
            position: "sticky",
            zIndex: 100,
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <p
            style={{
              fontSize: 14,
              color: "dodgerblue",
            }}
          >
            Total Amount {numberWithCommas(totalAmountCalculator(data))}
          </p>
        </div>
      </div>

      <div>
        <CustomButton
          title="Send"
          styles={{
            border: "none",
            minWidth: 250,
            maxWidth: 350,
            marginTop: 20,
          }}
          onClick={() => {
            onClickSubmit(data);
          }}
          loading={loading}
        />
      </div>
    </div>
  );
}

export default DisplayBulk;
